<h1 mat-dialog-title class="p-2 text-center" i18n>Ajout d'un jeu de limites </h1>
<div mat-dialog-content class="p-3">
    <mat-slide-toggle class="my-3" [(ngModel)]="Model.IsActive" i18n>Actif!</mat-slide-toggle>
    <div class="row align-items-center">
        <div class="col-12">
            <mat-form-field class="w-100">
                <input matInput [(ngModel)]="Model.Name" i18n-placeholder placeholder="Nom">
            </mat-form-field>
        </div>

        <div class="col-12 fst-italic" i18n>
            Couleurs des limites
        </div>
        <div class="col-6">
            <ngx-colors class="mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.OutOfLimitBackColor" [matTooltip]="GetColorName(Model.OutOfLimitBackColor)"></ngx-colors>
            <span class="align-super" i18n>Couleur de fond des alertes</span>
        </div>
        <div class="col-6 align-items-center">
            <ngx-colors class="mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.OutOfLimitForeColor" [matTooltip]="GetColorName(Model.OutOfLimitForeColor)"></ngx-colors>
            <span class="align-super" i18n>Couleur de texte des alertes</span>
        </div>

        <div class="col-6 align-items-center">
            <ngx-colors class="mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.BackColor" [matTooltip]="GetColorName(Model.BackColor)"></ngx-colors>
            <span class="align-super" i18n>Couleur de fond de l'en-tête de colonne</span>
        </div>
        <div class="col-6">
            <ngx-colors class="mx-1 d-inline-flex " [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.ForeColor" [matTooltip]="GetColorName(Model.ForeColor)"></ngx-colors>
            <span class="align-super" i18n>Couleur de texte de l'en-tête de colonne</span>
        </div>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col me-1" color="warn" mat-stroked-button (throttledClick)="deleteCategory()" i18n>
            Supprimer
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            {{ IsCreation ? 'Ajouter' : 'Modifier' }}
        </button>
    </div>
</div>